import React from 'react'
import ActivitiesLibrary from './ActivitiesLibrary'

const FavoritesLibrary = () => (
  <>
    <ActivitiesLibrary
      showOnlyFavorites
    />
  </>
)

export default FavoritesLibrary
